import type { WorldBuilderResult } from '@creanizer/types'

interface WorldTechnologyProps {
  technology?: WorldBuilderResult['details']['technology']
}

export function WorldTechnology({ technology }: WorldTechnologyProps) {
  if (!technology) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        技術体系のデータがありません
      </div>
    )
  }
  
  return (
    <div className="space-y-4">
      <div>
        <h3 className="font-semibold mb-2">技術レベル</h3>
        <p className="text-sm text-muted-foreground">{technology.level}</p>
      </div>
      
      {technology.keyTechnologies && technology.keyTechnologies.length > 0 && (
        <div>
          <h4 className="text-sm font-semibold mb-2">主要技術</h4>
          <div className="grid grid-cols-2 gap-3">
            {technology.keyTechnologies.map((tech, index) => {
              const isObject = typeof tech === 'object' && tech !== null
              return (
                <div
                  key={index}
                  className="flex items-start gap-2 p-3 bg-blue-50 rounded-lg"
                >
                  <span className="text-blue-600 mt-0.5">⚡</span>
                  {isObject ? (
                    <div className="flex-1">
                      <div className="text-sm font-medium text-blue-700">
                        {(tech as any).name}
                      </div>
                      <div className="text-xs text-muted-foreground mt-1">
                        {(tech as any).description}
                      </div>
                    </div>
                  ) : (
                    <span className="text-sm">{String(tech)}</span>
                  )}
                </div>
              )
            })}
          </div>
        </div>
      )}
      
      {technology.limitations && technology.limitations.length > 0 && (
        <div>
          <h4 className="text-sm font-semibold mb-2">技術的制約</h4>
          <ul className="space-y-2">
            {technology.limitations.map((limitation, index) => {
              const isObject = typeof limitation === 'object' && limitation !== null
              return (
                <li key={index} className="flex items-start gap-2">
                  <span className="text-amber-500 mt-1">⚠</span>
                  {isObject ? (
                    <div className="flex-1">
                      <div className="text-sm font-medium text-amber-700">
                        {(limitation as any).name}
                      </div>
                      <div className="text-xs text-muted-foreground mt-1">
                        {(limitation as any).description}
                      </div>
                    </div>
                  ) : (
                    <span className="text-sm text-muted-foreground">{String(limitation)}</span>
                  )}
                </li>
              )
            })}
          </ul>
        </div>
      )}
      
      {technology.uniqueAspects && technology.uniqueAspects.length > 0 && (
        <div>
          <h4 className="text-sm font-semibold mb-2">独自の技術的側面</h4>
          <div className="space-y-2">
            {technology.uniqueAspects.map((aspect, index) => {
              const isObject = typeof aspect === 'object' && aspect !== null
              return (
                <div
                  key={index}
                  className="p-3 bg-gradient-to-r from-cyan-50 to-blue-50 rounded-lg"
                >
                  <div className="flex items-start gap-2">
                    <span className="text-cyan-600 mt-0.5">✦</span>
                    {isObject ? (
                      <div className="flex-1">
                        <div className="text-sm font-medium text-cyan-700">
                          {(aspect as any).name}
                        </div>
                        <div className="text-xs text-muted-foreground mt-1">
                          {(aspect as any).description}
                        </div>
                      </div>
                    ) : (
                      <p className="text-sm">{String(aspect)}</p>
                    )}
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      )}
    </div>
  )
}